// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".fail-enter-active,.fail-leave-active{transform:translate(0) translateZ(1px);transition:transform .5s}.fail-enter-from,.fail-leave-to{transform:translateY(100vh) translateY(0) translateZ(1px);transition:transform .7s}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
